import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home";
import Benefits from "./components/Benefits";
import Blog from "./components/Blog";
import Features from "./components/Features";
import Uses from "./components/Uses";
import Tour from "./components/Tour";
import Footer from "./components/Footer";
import CREATE_MEMORIES from "./components/CREATE_MEMORIES";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tour" element={<Tour />} />
        <Route path="/uses" element={<Uses />} />
        <Route path="/features" element={<Features />} />
        <Route path="/benefits" element={<Benefits />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/create_memory" element={<CREATE_MEMORIES />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
